import { observable } from '@legendapp/state'
import { ObservablePersistMMKV } from '@legendapp/state/persist-plugins/mmkv'
import { synced } from '@legendapp/state/sync'

export const assetStore$ = observable({
  pinnedAssets: synced<Set<string>>({
    initial: new Set<string>(),
    persist: {
      plugin: ObservablePersistMMKV,
      name: 'pinnedAssets',
    },
  }),
  pinAsset: (assetId: string) => {
    const pinnedAssets = assetStore$.pinnedAssets.get()

    if (pinnedAssets.size >= 3) {
      const firstAsset = pinnedAssets.values().next().value

      if (firstAsset) {
        assetStore$.pinnedAssets.set(mutateSet(pinnedAssets, firstAsset))
      }
    }

    assetStore$.pinnedAssets.set(mutateSet(pinnedAssets, assetId))
  },
})

function mutateSet<T>(set: Set<T>, value: T) {
  const nextSet = new Set(set)

  if (nextSet.has(value)) {
    nextSet.delete(value)
  } else {
    nextSet.add(value)
  }

  return nextSet
}
